import { render } from "./PageTrendRadar.vue?vue&type=template&id=20abed15&scoped=true"
import script from "./PageTrendRadar.vue?vue&type=script&lang=js"
export * from "./PageTrendRadar.vue?vue&type=script&lang=js"

import "./PageTrendRadar.vue?vue&type=style&index=0&id=20abed15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20abed15"]])

export default __exports__